import { useCallback, useEffect, useState } from "react";
import { ExternalLink, LogOut } from "lucide-react";
import { adminApi } from "../../lib/adminApi";
import AdminProducts from "./AdminProducts";
import AdminBlog from "./AdminBlog";

const AdminPanel = ({ user, onLogout }) => {
    const [tab, setTab] = useState("productos");
    const [products, setProducts] = useState([]);
    const [posts, setPosts] = useState([]);

    const reload = useCallback(async () => {
        try {
            const [prodRes, blogRes] = await Promise.all([adminApi.get("/products"), adminApi.get("/blog")]);
            setProducts(prodRes.data);
            setPosts(blogRes.data);
        } catch (e) {
            console.error("Error cargando datos del panel", e);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    return (
        <div data-testid="admin-panel" className="min-h-screen bg-white">
            <header className="sticky top-0 z-40 bg-brand-ink">
                <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
                    <div className="flex items-center gap-3">
                        <img src="/assets/logo-lolopets-outline.png" alt="LoloPets" className="h-9 w-auto" />
                        <span className="hidden font-display text-sm font-semibold text-white sm:inline">Panel de administración</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <a
                            data-testid="admin-view-site"
                            href="/"
                            className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full px-4 text-sm font-semibold text-white/80 transition-colors hover:text-white"
                        >
                            <ExternalLink className="h-4 w-4" /> Ver sitio
                        </a>
                        <button
                            data-testid="admin-logout"
                            onClick={onLogout}
                            className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full bg-white/10 px-4 text-sm font-semibold text-white transition-colors hover:bg-white/20"
                        >
                            <LogOut className="h-4 w-4" /> Salir
                        </button>
                    </div>
                </div>
            </header>

            <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6">
                <p className="text-sm text-brand-muted">
                    Sesión: <span className="font-semibold text-brand-ink">{user?.email}</span>
                </p>
                <div className="mt-5 flex gap-2" role="tablist" aria-label="Secciones del panel">
                    {[
                        { id: "productos", label: "Productos" },
                        { id: "blog", label: "Blog / Consejos" },
                    ].map((t) => (
                        <button
                            key={t.id}
                            data-testid={`admin-tab-${t.id}`}
                            role="tab"
                            aria-selected={tab === t.id}
                            onClick={() => setTab(t.id)}
                            className={`min-h-[44px] rounded-full px-6 font-display text-sm font-semibold transition-all duration-300 ${
                                tab === t.id ? "bg-brand-magenta text-white shadow-soft" : "bg-black/[0.04] text-brand-ink hover:bg-black/[0.08]"
                            }`}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
                <div className="mt-8">
                    {tab === "productos" ? <AdminProducts products={products} reload={reload} /> : <AdminBlog posts={posts} reload={reload} />}
                </div>
            </main>
        </div>
    );
};

export default AdminPanel;
